<template>
  <div>
    <Subheader title="Password Reset" />

    <div class="app-content-column">
      <div class="card">
        <h5>Email Sent!</h5>

        <p>
          Check your email to continue resetting your password. You may have to wait a few minutes
          or check your spam folder.
        </p>

        <div class="button-wrapper is-centered">
          <router-link :to="{ name: 'Login' }">
            <button type="submit" class="large-button">
              Return to log in page
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Subheader from '@/components/Subheader'

export default {
  name: 'ForgotPasswordSuccess',
  components: {
    Subheader,
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/cards';
@import '../../styles/mixins/buttons';
@import '../../styles/forms';
@import '../../styles/layout';

.card {
  @include card-w-borders();
}
</style>
